export const constants = {
  defaultUserAvatar: 'https://assets.keepsdev.com/images/avatars/avatar-placeholder.png',
  defaultWorkspaceLogo: 'https://assets.keepsdev.com/images/avatars/company_blue.png',
  defaultPageSizeOptions: [10, 25, 50, 100],
  defaultMobileWidth: '432px',
  defaultMobileLandscapeWidth: '768px',
  linkedinShareUrl: 'https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=',

  // eslint-disable-next-line no-useless-escape
  defaultLinkRegex: /^((https?:\/\/)|(www))?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:\/?#[\]@!$&'()*+,;=]/s,
};
